/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDesiredPolicyFieldsInput } from './CRSFSecReviewDesiredPolicyFieldsInput';
import {
    CRSFSecReviewDesiredPolicyFieldsInputFromJSON,
    CRSFSecReviewDesiredPolicyFieldsInputFromJSONTyped,
    CRSFSecReviewDesiredPolicyFieldsInputToJSON,
} from './CRSFSecReviewDesiredPolicyFieldsInput';
import type { CRSFSecReviewLocale } from './CRSFSecReviewLocale';
import {
    CRSFSecReviewLocaleFromJSON,
    CRSFSecReviewLocaleFromJSONTyped,
    CRSFSecReviewLocaleToJSON,
} from './CRSFSecReviewLocale';

/**
 * The secondary scan trigger.
 * @export
 * @interface CRSFSecReviewTrigger
 */
export interface CRSFSecReviewTrigger {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTrigger
     */
    account_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTrigger
     */
    cobranded?: string;
    /**
     * 
     * @type {CRSFSecReviewDesiredPolicyFieldsInput}
     * @memberof CRSFSecReviewTrigger
     */
    desired_policy_fields?: CRSFSecReviewDesiredPolicyFieldsInput;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTrigger
     */
    desired_policy_uuid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewTrigger
     */
    dry_run?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewTrigger
     */
    force?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTrigger
     */
    issue_key: string;
    /**
     * 
     * @type {CRSFSecReviewLocale}
     * @memberof CRSFSecReviewTrigger
     */
    locale?: CRSFSecReviewLocale;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewTrigger
     */
    new_domains_at_bind?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTrigger
     */
    renewal_of_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTrigger
     */
    request_origin?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTrigger
     */
    retained_from_uuid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewTrigger
     */
    scan_web_sev2_force?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewTrigger
     */
    signal_id?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewTrigger
     */
    user?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewTrigger interface.
 */
export function instanceOfCRSFSecReviewTrigger(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "issue_key" in value;

    return isInstance;
}

export function CRSFSecReviewTriggerFromJSON(json: any): CRSFSecReviewTrigger {
    return CRSFSecReviewTriggerFromJSONTyped(json, false);
}

export function CRSFSecReviewTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewTrigger {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_uuid': !exists(json, 'account_uuid') ? undefined : json['account_uuid'],
        'cobranded': !exists(json, 'cobranded') ? undefined : json['cobranded'],
        'desired_policy_fields': !exists(json, 'desired_policy_fields') ? undefined : CRSFSecReviewDesiredPolicyFieldsInputFromJSON(json['desired_policy_fields']),
        'desired_policy_uuid': !exists(json, 'desired_policy_uuid') ? undefined : json['desired_policy_uuid'],
        'dry_run': !exists(json, 'dry_run') ? undefined : json['dry_run'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'issue_key': json['issue_key'],
        'locale': !exists(json, 'locale') ? undefined : CRSFSecReviewLocaleFromJSON(json['locale']),
        'new_domains_at_bind': !exists(json, 'new_domains_at_bind') ? undefined : json['new_domains_at_bind'],
        'renewal_of_uuid': !exists(json, 'renewal_of_uuid') ? undefined : json['renewal_of_uuid'],
        'request_origin': !exists(json, 'request_origin') ? undefined : json['request_origin'],
        'retained_from_uuid': !exists(json, 'retained_from_uuid') ? undefined : json['retained_from_uuid'],
        'scan_web_sev2_force': !exists(json, 'scan_web_sev2_force') ? undefined : json['scan_web_sev2_force'],
        'signal_id': !exists(json, 'signal_id') ? undefined : json['signal_id'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function CRSFSecReviewTriggerToJSON(value?: CRSFSecReviewTrigger | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_uuid': value.account_uuid,
        'cobranded': value.cobranded,
        'desired_policy_fields': CRSFSecReviewDesiredPolicyFieldsInputToJSON(value.desired_policy_fields),
        'desired_policy_uuid': value.desired_policy_uuid,
        'dry_run': value.dry_run,
        'force': value.force,
        'issue_key': value.issue_key,
        'locale': CRSFSecReviewLocaleToJSON(value.locale),
        'new_domains_at_bind': value.new_domains_at_bind,
        'renewal_of_uuid': value.renewal_of_uuid,
        'request_origin': value.request_origin,
        'retained_from_uuid': value.retained_from_uuid,
        'scan_web_sev2_force': value.scan_web_sev2_force,
        'signal_id': value.signal_id,
        'user': value.user,
    };
}

